module.exports = __webpack_public_path__ + "static/media/loading_circle.d8a0f073.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/loading_circle.gif
// module id = 551
// module chunks = 0